var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"历史曲线","visible":_vm.dialogVisible,"width":"100%","top":"0px","center":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('realTimeEcharts',{ref:"realTimeEcharts"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }